/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import m from 'mithril';
import PubSub from 'pubsub-js';
import { runQuery, runMutation } from '../utils/fetchData';
import addProjectModal from '../pages/projects/addProjects';
import addTeamModal from '../pages/teams/addTeam';
import dataMap from '../utils/data';

import actions from '../utils/actionsMap';


const brandLogo = {
  async oninit() {
    const token = localStorage.getItem('token');

    if (!token) {
      return window.location.replace('/login');
    }
  },
  view() {
    return m(".k-aside__brand.k-grid__item.[id='k_aside_brand']",
      [
        m('.k-aside__brand-logo',
          m('a', {
            href: '/',
            oncreate: m.route.link,
            onupdate: m.route.link,
          },
            m("img[alt='Logo'][src='/assets/media/logos/all-white.png']", {
              style: {
                height: '18px',
              },
            }))),
        m('.k-aside__brand-tools',
          m("button.k-aside__brand-aside-toggler.k-aside__brand-aside-toggler--left[id='k_aside_toggler']",
            m('span'))),
      ]);
  },
};

const subMenuItem = {
  view({
    attrs,
  }) {
    const {
      onclick,
      title,
      active, icon, href,
      oncreate,
      onupdate,
      target,
    } = attrs;
    return m('li.k-menu__item', {
      class: `${active ? 'k-menu__item--active' : ''}`,
      'aria-haspopup': 'true',

    },
      m('a.k-menu__link', {
        href,
        oncreate,
        onupdate,
        onclick,
        target,
        'data-intro': attrs['data-intro'],
        'data-position': attrs['data-position'],
        'data-step': attrs['data-step'],
      },
        [
          !icon
            ? m('i.k-menu__link-bullet.k-menu__link-bullet--dot',
              m('span'))
            : m(`i.k-menu__link-icon.${icon}`),
          m('span.k-menu__link-text',
            title),
        ]));
  },
};

const subMenuHeader = {
  view({ attrs: { title, icon } }) {
    return m("a.k-menu__link.k-menu__toggle[href='javascript:;']",
      [
        m(`i.k-menu__link-icon.${icon}`),
        m('span.k-menu__link-text',
          title),
        m('i.k-menu__ver-arrow.la.la-angle-right'),
      ]);
  },
};

const menuItem = {
  view({
    attrs: {
      active, title, icon, href, oncreate, onupdate, target,
    },
  }) {
    return m("li.k-menu__item.[aria-haspopup='true']", {
      class: `${active ? 'k-menu__item--active' : ''}`,
      'aria-haspopup': 'true',
    },
      m('a.k-menu__link', {
        href,
        oncreate,
        onupdate,
        target,
      },
        [
          m(`i.k-menu__link-icon.${icon}`),
          m('span.k-menu__link-text',
            title),
        ]));
  },
};

const sectionHeader = {
  view({ attrs: { title } }) {
    return m('li.k-menu__section.',
      [
        m('h4.k-menu__section-text',
          title),
        m('i.k-menu__section-icon.flaticon-more-v2'),
      ]);
  },
};

export default {
  async oninit({ state }) {
    Object.assign(state, {
      projects: [],
      teams: [],
    });

    PubSub.subscribe(actions.UPDATE_PROJECT, (msg, { id, name }) => {
      const oldProject = state.projects.filter(project => project.id === id)[0];
      oldProject.name = name;

      Object.assign(state, {
        projects: [...state.projects.filter(project => project.id !== id), oldProject],
      });

      m.redraw();
    });

    PubSub.subscribe(actions.UPDATE_TEAM, (msg, { id, name }) => {
      const oldTeam = state.teams.filter(team => team.id === id)[0];
      oldTeam.name = name;

      Object.assign(state, {
        teams: [...state.teams.filter(team => team.id !== id), oldTeam],
      });

      m.redraw();
    });

    PubSub.subscribe(actions.DELETE_PROJECT, async (msg, { id }) => {
      Object.assign(state, {
        projects: state.projects.filter(project => project.id !== id),
      });
    });

    PubSub.subscribe(actions.DELETE_TEAM, async (msg, { id }) => {
      Object.assign(state, {
        teams: state.teams.filter(team => team.id !== id),
      });
      m.redraw();
    });

    const client = await dataMap.getClientData();

    Object.assign(state, client);
    m.redraw();

    // listen for a new client
    PubSub.subscribe(actions.CLIENT_VIEW_CHANGE, async (msg) => {
      const client = await dataMap.getClientData();

      Object.assign(state, client);
      m.route.set('/');
      m.redraw();
    });
  },
  // oncreate() {
  //   KLayout.init();
  // },
  view({ state, attrs }) {
    return m("div", {
      "class": "d-none d-lg-flex flex-column flex-lg-row-auto w-100 w-lg-200px drawer",
      "data-kt-drawer": "true",
      "data-kt-drawer-name": "inbox-aside",
      "data-kt-drawer-activate": "{default: true, lg: false}",
      "data-kt-drawer-overlay": "true",
      "data-kt-drawer-width": "225px",
      "data-kt-drawer-direction": "start",
      "data-kt-drawer-toggle": "#kt_inbox_aside_toggle",
      style: {
        ".drawer": {
          "position": "relative" /* add this to allow for absolute positioning of the line */
        },
        ".drawer::after": {
          "content": "''",
          "position": "absolute",
          "top": 0,
          "right": 0,
          "width": "3px", /* adjust the width to your liking */
          "height": "100vh", /* make it go all the way to the page bottom */
          "background-color": "#333" /* adjust the color to your liking */
        }
      }
    },
      m("div", { "class": "cardx cardx-flush mb-0", "data-kt-sticky": "false", "data-kt-sticky-name": "inbox-aside-sticky", "data-kt-sticky-offset": "{default: false, xl: '100px'}", "data-kt-sticky-width": "{lg: '275px'}", "data-kt-sticky-left": "auto", "data-kt-sticky-top": "100px", "data-kt-sticky-animation": "false", "data-kt-sticky-zindex": "95" },
        m("div", { "class": "cardx-body" },
          m("div", { "class": "menu menu-column menu-rounded menu-state-bg menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary mb-10" },
            [
              attrs.sideBarItems.map(({ label, icon, svg, route, routesToActivate }) => {
                const currentRoute = m.route.get();
                const isActive = Array.isArray(routesToActivate) ? routesToActivate.includes(currentRoute) : currentRoute === route;
                return [
                  m("div", {
                    "class": "menu-item mb-3",
                    style: {
                      cursor: 'pointer'
                    }
                  },
                    m("span", {
                      "class": `menu-link ${isActive ? 'active' : ''}`,
                      onclick: () => {
                        m.route.set(route);
                        window.location.reload();
                      },
                    },
                      [
                        m("span", { "class": "menu-icon" },
                          m("i", { "class": `ki-duotone ${icon} fs-2 me-3` },
                            [
                              m("span", { "class": "path1" }),
                              m("span", { "class": "path2" })
                            ]
                          )
                        ),
                        m("span", { "class": "menu-title fw-bold" },
                          label
                        )
                      ]
                    )
                  ),
                  m("div", { "class": "separator my-3" })
                ]
              })

            ]
          )
        )
      )
    )
  },
};
